import { BOOKMARKS_START_LOADER, BOOKMARKS_STOP_LOADER, BOOKMARKS_ERROR, BOOKMARKS_HIDE_ERROR, DECREASE_BOOKMARKS_COUNT, INCREASE_BOOKMARKS_COUNT, UPDATE_BOOKMARKS_COUNT, } from "../interface/iBookmarks";
import store from "@redux/store";
var BookmarksActions = /** @class */ (function () {
    function BookmarksActions() {
        this.dispatch = store.dispatch;
    }
    BookmarksActions.prototype.increaseBookmarksCount = function (addedBookmarksCount) {
        this.dispatch({
            type: INCREASE_BOOKMARKS_COUNT,
            payload: { totalCount: addedBookmarksCount },
        });
    };
    BookmarksActions.prototype.decreaseBookmarksCount = function (removedBookmarksCount) {
        this.dispatch({
            type: DECREASE_BOOKMARKS_COUNT,
            payload: { totalCount: removedBookmarksCount },
        });
    };
    BookmarksActions.prototype.updateBookmarksCount = function (totalBookmarksCount) {
        this.dispatch({
            type: UPDATE_BOOKMARKS_COUNT,
            payload: { totalCount: totalBookmarksCount },
        });
    };
    BookmarksActions.prototype.startBookmarksLoader = function () {
        this.dispatch({
            type: BOOKMARKS_START_LOADER,
        });
    };
    BookmarksActions.prototype.stopBookmarksLoader = function () {
        this.dispatch({
            type: BOOKMARKS_STOP_LOADER,
        });
    };
    BookmarksActions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: BOOKMARKS_ERROR,
            payload: { errorData: payload },
        });
    };
    BookmarksActions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: BOOKMARKS_HIDE_ERROR,
        });
    };
    return BookmarksActions;
}());
export default BookmarksActions;
